import React, { useState } from 'react';
import { Wrench, Phone, CheckCircle2, ShieldCheck, ArrowRight } from 'lucide-react';
const PHONE = '586-203-3701';
export function Hero() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({
    name: '',
    phone: '',
    zip: ''
  });
  const update = (k: string, v: string) => setForm(f => ({
    ...f,
    [k]: v
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
    // After 2s, scroll to full form for additional details
    setTimeout(() => {
      document.getElementById('quote-form')?.scrollIntoView({
        behavior: 'smooth'
      });
    }, 1500);
  };
  return <section id="top" className="relative bg-[#1a2332] overflow-hidden" data-id="element-134" data-mp="nczt16jsw3vm">
      {/* Background: real shingle roof close-up */}
      <div className="absolute inset-0" data-id="element-135" data-mp="3d33fx1m3uzmc">
        <img src="https://images.unsplash.com/photo-1632759145355-8b8f3f5e6a7e?w=1600&q=80&auto=format&fit=crop" alt="" aria-hidden="true" className="w-full h-full object-cover opacity-30" onError={e => {
        ;
        (e.currentTarget as HTMLImageElement).src = 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?w=1600&q=80&auto=format&fit=crop';
      }} data-id="element-136" data-mp="382fgbrjt9agi" />
        <div className="absolute inset-0 bg-gradient-to-br from-[#1a2332]/95 via-[#1a2332]/85 to-[#1a2332]/95" data-id="element-137" data-mp="3e84nlcz10yuk" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 sm:py-20 lg:py-24" data-id="element-138" data-mp="30gq1uydqijjt">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center" data-id="element-139" data-mp="35a2h4hwixdzw">
          {/* LEFT: Copy */}
          <div className="lg:col-span-7 text-white" data-id="element-140" data-mp="2qhqv5lcj4xzg">
            <div className="inline-flex items-center gap-2 mb-5" data-id="element-141" data-mp="2vi50uwqnrvub">
              <Wrench className="w-5 h-5 text-[#2DB8E0]" data-id="element-142" data-mp="2hj5czrayzkz7" />
              <span className="font-semibold text-white/90 tracking-wide text-sm sm:text-base" data-id="element-143" data-mp="2hjoxnfs08ngx">
                Moceri Residential Services LLC
              </span>
            </div>

            <h1 className="font-display italic font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight mb-5 text-white" data-id="element-144" data-mp="s2tenov66frb">
              Michigan Shingle Roof Replacement Experts
            </h1>

            <div className="w-24 h-px bg-[#2DB8E0] mb-6" data-id="element-145" data-mp="icrn2n3lyf7n" />

            <p className="text-lg text-white/85 leading-relaxed mb-6 max-w-2xl" data-id="element-146" data-mp="ddnfg0wc0pjf">
              Premium architectural shingles built for Michigan weather. Upfront
              pricing, no missed appointments, and a workmanship guarantee that
              backs every job.
            </p>

            <ul className="space-y-2.5 mb-8" data-id="element-147" data-mp="112g7vndqwf9a">
              {['Free, no-obligation roof inspection', 'Written estimates with upfront pricing', '25 to 50 year lifetime warranties', 'Licensed & insured Michigan crew'].map(item => <li key={item} className="flex items-center gap-3" data-id="element-148" data-mp="3hr3rdunnk95a">
                  <CheckCircle2 className="w-5 h-5 text-[#2DB8E0] flex-shrink-0" data-id="element-149" data-mp="1x9b5n20k33d3" />
                  <span className="text-white/90 font-medium" data-id="element-150" data-mp="1x7871tlc81wr">{item}</span>
                </li>)}
            </ul>

            <div className="flex flex-wrap items-center gap-x-5 gap-y-3" data-id="element-151" data-mp="26a96xcjm0wrz">
              <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 text-white hover:text-[#2DB8E0] font-bold text-lg transition-colors" data-id="element-152" data-mp="26868c44e5vbn">
                <Phone className="w-5 h-5 text-[#2DB8E0]" data-id="element-153" data-mp="2kyn9dmd46j80" />
                {PHONE}
              </a>
              <span className="text-white/40" data-id="element-154" data-mp="2p0qp4n6tg9z3">|</span>
              <div className="flex items-center gap-2" data-id="element-155" data-mp="2p10imkr2kz9j">
                <ShieldCheck className="w-5 h-5 text-[#2DB8E0]" data-id="element-156" data-mp="2u03kjwbr6pda" />
                <span className="font-bold text-sm sm:text-base" data-id="element-157" data-mp="2tx7lu5s2zwns">
                  <span className="text-[#2DB8E0]" data-id="element-158" data-mp="uo0shxp2cmo0">$500 OFF</span> this month
                </span>
              </div>
            </div>
          </div>

          {/* RIGHT: Mini lead form */}
          <div className="lg:col-span-5" data-id="element-159" data-mp="4a2t1g0r31xi">
            <div className="bg-white rounded-2xl shadow-2xl p-6 sm:p-7 relative overflow-hidden" data-id="element-160" data-mp="4d73gv4t6twm">
              <div className="absolute top-0 left-0 w-full h-1.5 bg-[#2DB8E0]" data-id="element-161" data-mp="3vk1n8a7amn31" />

              {submitted ? <div className="text-center py-6" data-id="element-162" data-mp="9aqkg2sw5ks9">
                  <div className="w-14 h-14 bg-[#2DB8E0]/10 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-163" data-mp="9b0a1pa0xpxf">
                    <CheckCircle2 className="w-8 h-8 text-[#2DB8E0]" data-id="element-164" data-mp="3ho64c4cw9bzn" />
                  </div>
                  <h3 className="font-display italic text-2xl text-[#1a2332] mb-2" data-id="element-165" data-mp="3cp320roatjvd">
                    Got it, {form.name.split(' ')[0] || 'thanks'}!
                  </h3>
                  <p className="text-slate-600 mb-4 text-sm" data-id="element-166" data-mp="3mollz847l5nf">
                    Add a few more details below so we can prepare your free
                    quote faster…
                  </p>
                  <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-2 text-[#1a9cc4] hover:text-[#1a2332] font-bold" data-id="element-167" data-mp="2tzws9u5hg2lp">
                    <Phone className="w-4 h-4" data-id="element-168" data-mp="1eayix5k0cesp" /> Or call now: {PHONE}
                  </a>
                </div> : <form onSubmit={handleSubmit} className="space-y-3" data-id="element-169" data-mp="zimzogreecvy">
                  <div className="text-center mb-2" data-id="element-170" data-mp="14ju54962izzg">
                    <div className="inline-flex items-center gap-1.5 bg-[#2DB8E0]/10 border border-[#2DB8E0]/30 text-[#1a9cc4] rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider mb-3" data-id="element-171" data-mp="1s8n6wm9dg21z">
                      $500 Off — Limited Time
                    </div>
                    <h2 className="font-display italic text-2xl sm:text-3xl text-[#1a2332] leading-tight" data-id="element-172" data-mp="1jatdpk6wloj1">
                      Get Your Free Roof Quote
                    </h2>
                    <p className="text-xs sm:text-sm text-slate-500 mt-1" data-id="element-173" data-mp="7s0ed8616ngh">
                      Takes 30 seconds. No obligation.
                    </p>
                  </div>

                  <div data-id="element-174" data-mp="2eg93oo2wgb9x">
                    <label htmlFor="hero-name" className="sr-only" data-id="element-175" data-mp="2ejn3bok6i6do">
                      Full Name
                    </label>
                    <input id="hero-name" type="text" required value={form.name} onChange={e => update('name', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="Full Name *" data-id="element-176" data-mp="24rhdakdhlz14" />
                  </div>

                  <div data-id="element-177" data-mp="1gu209hic0oz5">
                    <label htmlFor="hero-phone" className="sr-only" data-id="element-178" data-mp="1guv68g9gvag8">
                      Phone
                    </label>
                    <input id="hero-phone" type="tel" required value={form.phone} onChange={e => update('phone', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="Phone Number *" data-id="element-179" data-mp="3g64pl8dn0dkq" />
                  </div>

                  <div data-id="element-180" data-mp="1cymjhbibm0y">
                    <label htmlFor="hero-zip" className="sr-only" data-id="element-181" data-mp="30pzdpyg7uvut">
                      ZIP Code
                    </label>
                    <input id="hero-zip" type="text" required value={form.zip} onChange={e => update('zip', e.target.value)} className="w-full px-4 py-3 rounded-lg border border-slate-300 focus:ring-2 focus:ring-[#2DB8E0] focus:border-[#2DB8E0] outline-none transition-all" placeholder="ZIP Code *" data-id="element-182" data-mp="34qt0gohxa4m4" />
                  </div>

                  <button type="submit" className="w-full bg-[#2DB8E0] hover:bg-[#1a9cc4] text-white font-bold text-base py-4 rounded-full transition-all shadow-md hover:shadow-lg flex items-center justify-center gap-2" data-id="element-183" data-mp="1f2smop28bwa2">
                    Get My Free Quote + $500 Off
                    <ArrowRight className="w-5 h-5" data-id="element-184" data-mp="1k13wx0wfs8st" />
                  </button>

                  <p className="text-xs text-center text-slate-500 flex items-center justify-center gap-1.5 pt-1" data-id="element-185" data-mp="1yqi17ul5o01c">
                    <ShieldCheck className="w-3.5 h-3.5" data-id="element-186" data-mp="1tryevt2ngm8g" /> Your info is secure.
                    We never share it.
                  </p>

                  <div className="border-t border-slate-100 pt-3 text-center" data-id="element-187" data-mp="22t4y49woob5e">
                    <a href={`tel:${PHONE.replace(/-/g, '')}`} className="inline-flex items-center gap-1.5 text-[#1a2332] hover:text-[#2DB8E0] font-bold text-sm transition-colors" data-id="element-188" data-mp="22r24lfwbnzvx">
                      <Phone className="w-4 h-4 text-[#2DB8E0]" data-id="element-189" data-mp="2k27a4enctemk" /> Prefer to
                      call? {PHONE}
                    </a>
                  </div>
                </form>}
            </div>
          </div>
        </div>
      </div>
    </section>;
}